// Generated by ts-to-zod
import { z } from 'zod';

export const automationLevelSchema = z.union([
  z.literal('always'),
  z.literal('confident'),
  z.literal('never'),
]);
